import { useDateNow, useReduxState } from 'hooks';
import { CalendarEventDateString } from 'components/calendar';
import { CardExtension, CardProgressStatus } from 'components/common/tasks';
import { PathStepTileContent, PathStepTilePicture } from '.';

import type { CalendarEventProgress, PathStepItemEvent } from 'shared-types';

interface Props {
  event: PathStepItemEvent['event'] & { progressData: CalendarEventProgress };
}

const PathStepTileCalendarEvent = ({ event }: Props) => {
  const { dateNow } = useDateNow();

  const { messages, theme } = useReduxState();

  return (
    <div className="event">
      <PathStepTilePicture icon={['far', 'calendar-days']} />

      <PathStepTileContent
        description={event.description}
        subtitle={
          <div>
            <CalendarEventDateString
              startDate={event.startDate}
              endDate={event.endDate}
            />
          </div>
        }
        title={event.title}
      >
        <div className="footer">
          <div className="status">
            {event.progressData?.completionDate ? (
              <CardProgressStatus
                category="success"
                icon="check"
                label={messages.eventCalendarParticipantParticipated}
              />
            ) : event.progressData && Date.parse(event.startDate) < dateNow ? (
              <CardProgressStatus
                category="default"
                icon="hourglass-start"
                label={messages.commonInProgress}
              />
            ) : (
              <CardProgressStatus
                category="default"
                icon="minus"
                label={messages.eventCalendarParticipantNotParticipated}
              />
            )}
          </div>
        </div>
      </PathStepTileContent>

      {!event.progressData?.completionDate ? (
        <CardExtension
          icon="exclamation-circle"
          innerStyle={{ color: theme.textColorLight }}
        >
          {messages.pathsStepsRequiresAdminAction}
        </CardExtension>
      ) : null}

      <style jsx>{`
        .footer {
          margin-top: auto;
          padding-top: 20px;
        }
      `}</style>
    </div>
  );
};

export default PathStepTileCalendarEvent;
